<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <h1 class="m-0 text-dark text-uppercase">{{ $t('lsFundsNotDistributed')}}</h1>
        <h4>{{ availableAmount | displayAmount('IDR') }}</h4> 
      </div>
    </div>

    <div @submit.prevent="createStatement" class="content">
      <div class="container-fluid">
        <div class="col-12">
          <form class="form-horizontal">
            <div class="form-group row">
              <label class="col-sm-2 control-label">{{ $t('lsLoanId')}}</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" v-model="statementForm.loanId" required="true" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 control-label">{{ $t('lsProduct')}}</label>
              <div class="col-sm-10">
                <input type="text" class="form-control text-left" v-model="statementForm.product" required="true" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 control-label">{{ $t('lsBorrower')}}</label>
              <div class="col-sm-10">
                <input type="text" class="form-control text-left" v-model="statementForm.borrower" required="true" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 control-label">{{ $t('lsStartDate')}}</label>
              <div class="col-sm-10">
                <input type="text" class="form-control text-left" id="cashing_date" v-model="statementForm.cashingDate" required="true" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 control-label">{{ $t('lsAmount')}}</label>
              <div class="col-sm-10">
                <input type="text" class="form-control text-left" v-model="statementForm.amount" required="true" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 control-label">{{ $t('lsInterest')}}</label>
              <div class="col-sm-10">
                <input type="text" class="form-control text-left" v-model="statementForm.interest" required="true" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 control-label">{{ $t('lsTenor')}}</label>
              <div class="col-sm-10">
                <input type="text" class="form-control text-left" v-model="statementForm.tenor" required="true" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 control-label">{{ $t('lsStatus')}}</label>
              <div class="col-sm-10">
                <input type="text" class="form-control text-left" v-model="statementForm.status" required="true" />
              </div>
            </div>

            <button type="submit" class="btn btn-success btn-rounded px-4" id="buttons">{{ $t('table.save')}}</button>
          </form>
          <h5 class="text-center text-success mt-2">{{dataSuccess}}</h5>
          <h5 class="text-center text-danger">{{dataErr}}</h5>

          <div class="info-transfer-pendanaan mt-5">
            <p>{{ $t('lsNote')}} <br />
            {{ $t('lsNoteContent1')}} <br />
            {{ $t('lsNoteContent2')}} <br />
            {{ $t('lsNoteContent3')}}<br />
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "addLoanStatement",
  data() {
    return {
      statementForm: {
        loanId: '',
        product: '',
        borrower: '',
        cashingDate: '',
        amount: '',
        interest: '',
        tenor: '',
        status: ''
      },
      availableAmount: '',
      dataSuccess: "",
      dataErr: ""
    }
  },
  mounted() {
    var self = this;
    $("#cashing_date").datepicker({
      dateFormat: 'dd M yy',
      onSelect:function(selectedDate, datePicker) {
        let formatSelectedDate = self.$options.filters.formatDate(selectedDate);
        self.statementForm.cashingDate = formatSelectedDate;
      }
    });
    this.getAvailableAmount()
  },
  methods: {
    getAvailableAmount() {
      // let url = "admin/v1/priority/summaries?name=available-amount"
      let url = "admin/v1/priority/investments/total-available-amount"
      this.$axios.get(url)
      .then(response => {
        let result = response.data.data
        this.availableAmount = result.notInvested
      })
      .catch(error => {
        this.dataErr = `Get data available amount failed, ${error}`
      })
    },
    createStatement() {
      this.resetMessage()
      this.$axios.post("admin/v1/priority/loan-statement", this.statementForm)
      .then(response => {
        this.dataSuccess = "Data Dana yang Belum Disalurkan Sukses disimpan";
        this.resetForm()
      })
      .catch(error => {
        this.dataErr = `Data Dana yang Belum Disalurkan Gagal disimpan, ${error}`
      })
    },
    resetMessage(){
      this.dataSuccess = "",
      this.dataErr = ""
    },
    resetForm() {
      let self = this
      Object.keys(this.statementForm).forEach(function(key, index) {
        self.statementForm[key] = '';
      });
    }
  }
}
</script>
